import React from "react";
import "./HomePage.scss";
import { isAutoServicesTenant } from "../../../utils/tenantBranding";

const FollowUs = () => {

    const fetchingTenant = window.location.hostname.split(".")[0];
    const autoServicesBranding = isAutoServicesTenant(fetchingTenant);

    const socialMedia = autoServicesBranding 
        ? [
            {
                logo: "/inta.png",
                name: "Instagram",
                link: "#", // Add autoservices Instagram link here
            },
            {
                logo: "/facebook.png",
                name: "Facebook",
                link: "#", // Add autoservices Facebook link here
            },
            {
                logo: "/linkdin.png",
                name: "LinkedIn",
                link: "#", // Add autoservices LinkedIn link here
            },
        ]
        : [
            {
                logo: "/inta.png",
                name: "Instagram",
                link: "https://www.instagram.com/euroreparindia/",
            },
            {
                logo: "/facebook.png",
                name: "Facebook",
                link: "https://www.facebook.com/profile.php?id=61574899152224",
            },
            {
                logo: "/linkdin.png",
                name: "LinkedIn",
                link: "https://www.linkedin.com/company/eurorepar-india/",
            },
        ];
    
    return (
        <div className="follow-us-cont">
            <div className="follow-us-left">
                <span className="follow-us-online">Follow Us Online</span>
                <span className="follow-us-arrow">
                    <i
                        className="bi bi-arrow-up-right-circle-fill"
                    
                    ></i>
                </span>
            </div>
            <div className="follow-us-right">
                {socialMedia.map((icon, index) => (
                    autoServicesBranding ? (
                        <span 
                            key={index}
                            className=""
                            style={{ opacity: 0.5, cursor: 'not-allowed' }}
                            title="Social links not available"
                        >
                            <img src={icon.logo} alt={`${icon.name} logo`} />
                        </span>
                    ) : (
                        <a
                            key={index}
                            href={icon.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={icon.name}
                        >
                            <img src={icon.logo} alt={`${icon.name} logo`} />
                        </a>
                    )
                ))}
            </div>
        </div>
    );
};

export default FollowUs;
